<svg fill="none" height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.536133 1L4.53613 5L8.53613 1" stroke="#009DD6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
